import React, { useState } from 'react';

import { CorePage, CorePageTitle } from '$/components';
import { HostsListUri, RootUri } from '$/features/routes';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import arrowRightLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-right-large';
import Icon from '@amzn/meridian/icon';
import Link from '@amzn/meridian/link';
import Divider from '@amzn/meridian/divider';
import { useHistory } from 'react-router-dom';

export function HostListPage(): JSX.Element {
  const history = useHistory();
  const [query, setQuery] = useState('');

  return (
    <CorePage
      title="Host Agents"
      header={<CorePageTitle title="Host Agents" />}
      breadcrumbs={[{ title: 'Host Agents', href: RootUri }]}
    >
      <Column spacing="400" maxWidth="100%" width={650}>
        <Text type="h200">Navigate to a Host Agent:</Text>
        <Input
          id="my-input"
          value={query}
          onChange={setQuery}
          type="text"
          placeholder=""
          label="Hostname"
          size="xlarge"
        />
        <Row alignmentHorizontal="end">
          <Button
            onClick={() => {
              history.push(`${HostsListUri}/${query}`);
            }}
          >
            <Icon tokens={arrowRightLargeTokens} />
          </Button>
        </Row>
        <Divider spacingAfter="500" spacingBefore="500" />
        {
          // TODO: add recently visited section
        }
        <Text type="h200">Recently Visited:</Text>
        <Link href="https://meridian.a2z.com/">examplehost1</Link>
        <Link href="https://meridian.a2z.com/">examplehost2</Link>
        <Link href="https://meridian.a2z.com/">examplehost3</Link>
      </Column>
    </CorePage>
  );
}
